<template>
    <div>
        <div v-if="loading" class="loading-overlay">

            <div class="loading-card">

                <div class="loading-spinner"></div>

                <div class="loading-message">
                    {{ loadingMessage || 'Consultando Ticket...' }}
                </div>

            </div>

        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <div class="input-group date" id="datetimepicker1">
                        <input type="number" class="form-control" placeholder="N° Ticket a Despachar..."
                            v-model="nro_ticket" v-on:keyup.enter="consultar_ticket">
                        <span class="input-group-addon input-group-append">
                            <button class="btn btn-primary btn-sm" type="button" @click="consultar_ticket()"> <span
                                    class="fas fa-search"></span></button>
                        </span>
                    </div>
                </div>
            </div>
            <!-- <div class="col-md-4">
                <div class="form-group">
                    <div class="input-group date" id="datetimepicker1">
                        <input type="text" class="form-control" placeholder="Consultar Ingreso Patente en Portería..." v-model="patente_camion" v-on:keyup.enter="consultar_patente">
                        <span class="input-group-addon input-group-append">
                        <button class="btn btn-primary btn-sm" type="button" @click="consultar_patente()"> <span class="fas fa-search"></span></button>
                        </span>
                    </div>
                </div>
                
            </div> -->
        </div>

        <!-- ALERT-->
        <div v-if="alert" class="dialog-overlay">

            <div class="dialog-box">

                <!-- HEADER -->
                <div class="dialog-header">
                    <div class="dialog-title">
                        <i :class="alert_icono"></i>
                        <span>{{ alert_mensaje }}</span>
                    </div>

                    <button class="dialog-close" @click="alert = false">
                        &times;
                    </button>
                </div>

                <!-- BODY -->
                <div class="dialog-body">

                    <!-- PERMISOS -->
                    <div v-if="alert_permisos && alert_permisos.length">
                        <h6 class="dialog-subtitle">Error de Permisos</h6>
                        <ul class="dialog-list">
                            <li v-for="(m, index) in alert_permisos" :key="'p' + index">
                                {{ m }}
                            </li>
                        </ul>
                    </div>

                    <!-- ERRORES -->
                    <div v-if="alert_errores && alert_errores.length">
                        <h6 class="dialog-subtitle text-danger">Errores de Validación</h6>
                        <ul class="dialog-list error">
                            <li v-for="(m, index) in alert_errores" :key="'e' + index">
                                {{ m }}
                            </li>
                        </ul>
                    </div>

                </div>

                <!-- FOOTER -->
                <div class="dialog-footer">
                    <button class="btn btn-primary btn-sm" @click="alert = false">
                        Entendido
                    </button>
                </div>

            </div>

        </div>
        <!-- ALERT-->

        <div class="card card-frame col-md-12">
            <div class="card-body">
                <div class="row mb-2">
                    <div class="col">
                        <strong>TICKET DESPACHO {{ isEtruck ? 'ETRUCK' : 'PESAMATIC' }}</strong>
                    </div>
                    <div class="col-auto" v-if="verificar_permiso('romanaCambiarSistemaPesaje')">
                        <div class="pesaje-switch text-center">
                            <div class="label">Sistema de Pesaje</div>

                            <label class="switch my-1">
                                <input type="checkbox" v-model="isEtruck">
                                <span class="slider"></span>
                            </label>

                            <div class="value">
                                {{ isEtruck ? 'Etruck' : 'Pesamatic' }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col table-responsive">
                        <table class="table align-items-center border">
                            <thead class="thead-blue">
                                <tr>
                                    <th class="text-center">PATENTE</th>
                                    <th class="text-center">N° TICKET</th>
                                    <th class="text-center">CICLO</th>
                                    <th class="text-center">CHOFER</th>
                                    <!-- <th>EMPRESA</th> -->
                                </tr>
                            </thead>
                            <tr>
                                <td class="text-center">{{ pesaje ? pesaje.patente : '' }}</td>
                                <td class="text-center">{{ pesaje ? pesaje.numero : '' }}
                                </td>
                                <td class="text-center">{{ pesaje? pesaje.ciclo :'' }}</td>
                                <td class="text-center">{{ nombre_conductor }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-4 table-responsive">
                        <table class="table align-items-center border">
                            <thead class="thead-light">
                                <tr>
                                    <th class="text-center" colspan="2"><b>INFORMACIÓN PESO BRUTO</b></th>
                                </tr>
                                <tr>
                                    <th>FECHA PESO BRUTO</th>
                                    <td>{{ pesaje ? pesaje.fechaBruto : null | fecha_hora }}
                                    </td>

                                </tr>
                                <tr>
                                    <th>PESO BRUTO</th>
                                    <td>{{ pesaje ? pesaje.pesoBrutoSinEnvase : '' }}</td>
                                </tr>
                            </thead>
                        </table>
                    </div>

                    <div class="col-md-4 table-responsive">
                        <table class="table align-items-center border">
                            <thead class="thead-light">
                                <tr>
                                    <th class="text-center" colspan="2"><b>INFORMACIÓN PESO TARA</b></th>
                                </tr>
                                <tr>
                                    <th>FECHA TARA</th>
                                    <td>{{ pesaje ? pesaje.fechaTara : null | fecha_hora }}
                                    </td>

                                </tr>
                                <tr>
                                    <th>PESO TARA</th>
                                    <td>{{ pesaje ? pesaje.pesoTaraSinEnvase : '' }}</td>
                                </tr>
                            </thead>
                        </table>
                    </div>



                    <div class="col-md-4 table-responsive">
                        <table class="table align-items-center border">
                            <thead class="thead-light">
                                <tr>
                                    <th class="text-center" colspan="2"><b>INFORMACIÓN PESO NETO</b></th>
                                </tr>
                                <tr>
                                    <th>PESO NETO INFORMADO</th>
                                    <td>{{ pesaje ? pesaje.pesoNeto : '' }}</td>

                                </tr>
                                <tr>
                                    <th>PESO NETO CORREGIDO</th>
                                    <td>{{ pesaje ? pesaje.pesoNetoCorregido : '' }}</td>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 table-responsive">
                        <table class="table align-items-center border">
                            <thead class="thead-skyblue2">
                                <tr>
                                    <th class="text-center">N° GUÍA</th>
                                    <th class="text-center">CLIENTE</th>
                                    <th class="text-center">SUCURSAL</th>
                                    <th class="text-center">PESO INFORMADO</th>
                                    <th class="text-center">PESO RECIBIDO</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(guia, index) in documentos" :key="index">
                                    <td class="text-center">{{ guia.numero }}</td>
                                    <td class="text-center">{{ guia.proveedor }}</td>
                                    <td class="text-center">{{ guia.sucursal }}</td>
                                    <td class="text-center">{{ guia.pesoInformado }}</td>
                                    <td class="text-center">{{ guia.pesoRecibido }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>


            </div>
        </div>

        <!-- <div :class="`alert alert-${alert_2_clase} fade show`" role="alert" v-if="alert_2">
            <span class="alert-icon"><i class="ni ni-check-bold"></i></span>
            <span class="alert-text"><strong>{{alert_2_mensaje}}</strong></span>
            <button type="button" class="close" aria-label="Close" @click="cerrar_alert_2">
                <span aria-hidden="true">&times;</span>
            </button>
            <ul>
                <li v-for="(e,idx) in errores" :key="idx">{{e}}</li>
            </ul>
        </div> -->

        <div class="card card-frame col-md-12">
            <div class="card-body">
                <div class="row mb-2">
                    <div class="col">
                        <strong>TICKET DESPACHO ROMANA</strong>
                    </div>
                    <div class="col text-right">
                        <button class="btn btn-primary btn-sm" :disabled="ticket_romana == null || saving"
                            @click="guardarTicket">Guardar</button>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col table-responsive">
                        <table class="table align-items-center border">
                            <thead class="thead-blue">
                                <tr>
                                    <th class="text-center">PATENTE</th>
                                    <th class="text-center">N° TICKET</th>
                                    <th class="text-center">CICLO</th>
                                    <th class="text-center">CHOFER</th>
                                    <!-- <th class="text-center">SELECCIONE MATERIA PRIMA</th> -->
                                </tr>
                            </thead>
                            <tr>
                                <td class="text-center">{{ ticket_romana ? ticket_romana.patente : '' }}</td>
                                <td class="text-center">{{ ticket_romana ? ticket_romana.codigo_ticket : '' }}</td>
                                <td class="text-center">{{ ticket_romana ? ticket_romana.ciclo_ticket ==
                                    2 ? 'Despacho' : 'Recepción' : '' }}</td>
                                <td class="text-center">{{ nombre_conductor }}</td>
                                <!-- <td class="text-center">
                                    <select class="form-control-sm full-width" v-model="ticket_romana.mp_tipos_id" @change="actualizarMateriaPrima">
                                        <option value="">-- Seleccionar --</option>
                                        <option v-for="(opc,index) in mp_tipos" :key="index" :value="opc.id">{{opc.nombre}}</option>
                                    </select>
                                </td> -->
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-4 table-responsive">
                        <table class="table align-items-center border">

                            <thead class="thead-light">
                                <tr>
                                    <th class="text-center" colspan="2">INFORMACIÓN PESO BRUTO</th>
                                </tr>
                                <tr>
                                    <th>FECHA PESO BRUTO</th>
                                    <td>{{ ticket_romana ? ticket_romana.fecha_hora_bruto : null | fecha_hora }}</td>

                                </tr>
                                <tr>
                                    <th>PESO BRUTO</th>
                                    <td>{{ ticket_romana ? ticket_romana.peso_vehiculo_bruto : '' }}</td>
                                </tr>
                            </thead>
                        </table>
                    </div>

                    <div class="col-md-4 table-responsive">
                        <table class="table align-items-center border">
                            <thead class="thead-light">
                                <tr>
                                    <th class="text-center" colspan="2">INFORMACIÓN PESO TARA</th>
                                </tr>
                                <tr>
                                    <th>FECHA TARA</th>
                                    <td>{{ ticket_romana ? ticket_romana.fecha_hora_tara : null | fecha_hora }}</td>

                                </tr>
                                <tr>
                                    <th>PESO TARA</th>
                                    <td>{{ ticket_romana ? ticket_romana.peso_vehiculo_tara : '' }}</td>
                                </tr>
                            </thead>
                        </table>
                    </div>



                    <div class="col-md-4 table-responsive">
                        <table class="table align-items-center border">
                            <thead class="thead-light">
                                <tr>
                                    <th class="text-center" colspan="2">INFORMACIÓN PESO NETO</th>
                                </tr>
                                <tr>
                                    <th>PESO NETO INFORMADO</th>
                                    <td>{{ ticket_romana ? ticket_romana.peso_informado : '' }}</td>

                                </tr>
                                <tr>
                                    <th>PESO NETO CORREGIDO</th>
                                    <td>{{ peso_neto_corregido_romana }}</td>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>


                <div class="row mt-5" v-for="(g, idx_guia) in guias_romana" :key="idx_guia">

                    <div class="col-md-12">
                        <div class="card guia-card mb-3">
                            <div class="card-header guia-card-header text-center">
                                GUÍA N° {{ g.numero_guia }}
                            </div>

                            <div class="card-body">

                                <!-- ===================== -->
                                <!-- DATOS DOCUMENTO -->
                                <!-- ===================== -->
                                <h6 class="section-title">Datos del Documento</h6>

                                <div class="row">

                                    <div class="col-md-2 form-item">
                                        <label>Tipo Documento</label>
                                        <select class="form-control form-control-sm" v-model="g.tipo_documento_id">
                                            <option v-for="(opc, index) in tipo_documentos" :key="index"
                                                :value="opc.id">
                                                {{ opc.tipo_documento }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-md-1 form-item">
                                        <label>Es Venta</label>
                                        <div class="d-flex align-items-center mt-1">
                                            <input type="checkbox" v-model="g.es_venta">
                                        </div>
                                    </div>

                                    <div class="col-md-2 form-item">
                                        <label>N° Guía</label>
                                        <input type="text" class="form-control form-control-sm" :value="g.numero_guia"
                                            disabled>
                                    </div>

                                    <div class="col-md-2 form-item">
                                        <label>Fecha</label>
                                            <input type="datetime-local" class="form-control form-control-sm"
                                            v-model="g.fecha">
                                    </div>

                                    <div class="col-md-3 form-item">
                                        <label>Empresa Destino</label>
                                        <select class="form-control form-control-sm" v-model="g.empresas_id" disabled>
                                            <option value="">-- Seleccionar --</option>
                                            <option v-for="(opc, index) in g.empresas" :key="index" :value="opc.id">
                                                {{ opc.nombre }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-md-2 form-item">
                                        <label>Sucursal</label>
                                        <select class="form-control form-control-sm" v-model="g.dependencias_id"
                                            disabled>
                                            <option value="">-- Seleccionar --</option>
                                            <option v-for="(opc, index) in g.sucursales" :key="index" :value="opc.id">
                                                {{ opc.nombre }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-md-2 form-item">
                                        <label>Peso Informado</label>
                                        <input type="number" class="form-control form-control-sm"
                                            v-model="g.peso_informado" disabled>
                                    </div>

                                    <div class="col-md-2 form-item">
                                        <label>Peso Romana</label>
                                        <input type="number" class="form-control form-control-sm" v-model="g.peso_real"
                                            disabled>
                                    </div>

                                </div>

                                <!-- ===================== -->
                                <!-- ARCHIVO GUÍA -->
                                <!-- ===================== -->
                                <h6 class="section-title mt-3">Archivo de Guía</h6>

                                <div class="row">

                                    <div class="col-md-6 form-item">

                                        <div class="upload-box">

                                            <!-- ALERT -->
                                            <div v-if="g.alert"
                                                :class="`alert alert-sm alert-${g.alert_clase} d-flex justify-content-between align-items-center mb-2`">
                                                <div>
                                                    <i :class="g.alert_icono"></i>
                                                    {{ g.alert_mensaje }}
                                                </div>
                                                <button type="button" class="close" @click="g.alert = false">
                                                    &times;
                                                </button>
                                            </div>

                                            <!-- ACCIONES -->
                                            <div class="upload-actions">
                                                <button v-show="g.url_guia != null && g.url_guia != ''"
                                                    class="btn btn-outline-danger btn-sm" @click="abrirPdf(g.url_guia)">
                                                    <i class="fas fa-file-pdf"></i> Ver PDF
                                                </button>
                                            </div>

                                            <!-- INPUT -->
                                            <label class="upload-input">
                                                <i class="fas fa-upload"></i>
                                                <span>Seleccionar archivo</span>

                                                <input type="file" :ref="`file${g.numero_guia}`"
                                                    @change="subirGuia($event, idx_guia)">
                                            </label>

                                            <small class="upload-hint">
                                                Puede reemplazar la guía subiendo un nuevo archivo
                                            </small>

                                        </div>

                                    </div>

                                </div>

                                <!-- ===================== -->
                                <!-- DETALLE DESPACHO -->
                                <!-- ===================== -->
                                <h6 class="section-title mt-3 d-flex justify-content-between align-items-center">
                                    Detalle de Despacho

                                    <button class="btn btn-success btn-sm" @click="agregarDetalle(idx_guia)">
                                        <i class="fas fa-plus"></i> Agregar
                                    </button>
                                </h6>

                                <div v-for="(detalle, idx) in g.guia_despacho_detalles" :key="idx" class="dato-row">

                                    <div class="row align-items-center">

                                        <div class="col-md-3 form-item">
                                            <label>Tipo Despacho</label>
                                            <select class="form-control form-control-sm"
                                                v-model="detalle.tipo_despacho_id">
                                                <option v-for="(opc, index) in tipo_despachos" :key="index"
                                                    :value="opc.id">
                                                    {{ opc.nombre }}
                                                </option>
                                            </select>
                                        </div>

                                        <div class="col-md-3 form-item">
                                            <label>Producto</label>
                                            <select class="form-control form-control-sm"
                                                v-model="detalle.despacho_productos_id">
                                                <option
                                                    v-for="(opc, index) in retornar_despacho_productos(detalle.tipo_despacho_id)"
                                                    :key="index" :value="opc.id">
                                                    {{ opc.producto }}
                                                </option>
                                            </select>
                                        </div>

                                        <div class="col-md-2 form-item">
                                            <label>Cantidad (m³)</label>
                                            <input type="number" class="form-control form-control-sm"
                                                v-model="detalle.m3">
                                        </div>

                                        <div class="col-md-2 form-item">
                                            <label>Cantidad (Kg)</label>
                                            <input type="number" class="form-control form-control-sm"
                                                v-model="detalle.peso_real">
                                        </div>

                                        <div class="col-md-2 text-center mt-3">
                                            <button class="btn btn-danger btn-sm" style="border-radius: 100%;"
                                                @click="quitarDetalle(detalle, idx, idx_guia)">
                                                <i class="fas fa-trash"></i>
                                            </button>
                                        </div>

                                    </div>

                                </div>

                                <div v-if="g.guia_despacho_detalles.length === 0" class="text-center text-muted py-3">
                                    No hay detalles agregados
                                </div>

                            </div>
                        </div>
                    </div>

                </div>


            </div>

            <div class="col-md-12">

                <div class="card guia-card mt-3">

                    <div class="card-body">

                        <!-- ACCIONES -->
                        <div class="d-flex justify-content-between align-items-center mb-2">

                            <button class="btn btn-warning btn-sm"
                                :disabled="!verificar_permiso('ROMANA_PesajeEtruckController_agregar_distribucion_despacho') || pesaje === null">
                                <i class="fas fa-industry"></i>
                                Materia Prima a Vertedero
                            </button>

                            <div v-if="ticket_romana" class="d-flex align-items-center gap-2">
                                <strong class="total-kilos">
                                    TOTAL: {{ kilos_distribuciones_nuevo }}
                                </strong>

                                
                            </div>

                        </div>

                        <div class="mb-2">
                            <label class="mb-0 d-flex align-items-center gap-2" v-if="ticket_romana">
                                    <input type="checkbox" v-model="ticket_romana.cerrado">
                                    Cerrado
                                </label>
                        </div>

                        <!-- TABLA -->
                        <div v-if="ticket_romana" class="table-modern">

                            <!-- HEADER -->
                            <div class="table-header">
                                <div>Fecha</div>
                                <div>Proveedor</div>
                                <div>Ticket</div>
                                <div>Guía</div>
                                <div>Materia Prima</div>
                                <div>Destino</div>
                                <div>Kilos Disp.</div>
                                <div>Seleccionar</div>
                                <div>Guía Despacho</div>
                                <div>Kilos</div>
                            </div>

                            <!-- BODY SCROLL -->
                            <div class="table-body" v-if="ticket_romana.cerrado == 0">

                                <div v-for="(d, idx) in distribuciones" :key="idx"
                                    :class="['table-row', { 'row-selected': d.seleccionado }]">

                                    <div>{{ d.fecha_hora_ticket | fecha_hora }}</div>
                                    <div>{{ d.proveedor }}</div>
                                    <div>{{ d.codigo_ticket }}</div>
                                    <div>{{ d.numero_guia }}</div>
                                    <div>{{ d.materia_prima }}</div>
                                    <div>{{ d.destino }}</div>

                                    <div class="text-right">
                                        {{ d.peso_real - d.despachado - d.kilos_despacho | formatear_miles }}
                                    </div>

                                    <div class="text-center">
                                        <input type="checkbox" v-model="d.seleccionado" @change="setear_kilos(d, idx)">
                                    </div>

                                    <div>
                                        

                                        <select class="form-control form-control-sm" v-model="d.guias_id">
                                            <option v-for="(guia, index) in guias_romana_distintas" :key="index"
                                                :value="guia.id">
                                                {{ guia.numero_guia }}
                                            </option>
                                        </select>
                                    </div>

                                    <div>
                                        <input type="number" class="form-control form-control-sm" v-model="d.kilos_despacho">
                                    </div>

                                </div>

                            </div>

                            <!-- MODO CERRADO -->
                            <div class="table-body" v-if="ticket_romana.cerrado == 1">

                                <div v-for="(d, idx) in distribuciones_ticket" :key="idx" class="table-row">

                                    <div>{{ d.fecha_hora_ticket | fecha_hora }}</div>
                                    <div>{{ d.proveedor }}</div>
                                    <div>{{ d.codigo_ticket }}</div>
                                    <div>{{ d.numero_guia }}</div>
                                    <div>{{ d.materia_prima }}</div>
                                    <div>{{ d.destino }}</div>

                                    <div class="text-right">
                                        {{ d.kilos_despacho | formatear_miles }}
                                    </div>

                                    <div></div>
                                    <div></div>
                                    <div></div>

                                </div>

                            </div>

                        </div>

                    </div>
                </div>

            </div>
        </div>


        <div v-if="showDialog" class="auto-dialog-overlay">

            <div class="auto-dialog-box">

                <!-- CERRAR -->
                <button class="auto-dialog-close" @click="closeDialog">
                    &times;
                </button>

                <!-- ICONO -->
                <div class="auto-dialog-icon">
                    <i :class="dialogIcon"></i>
                </div>

                <!-- MENSAJE -->
                <div class="auto-dialog-message">
                    {{ dialogMessage }}
                </div>

                <!-- PROGRESS -->
                <div class="auto-dialog-progress">
                    <div class="auto-dialog-progress-bar" :style="{ width: progress + '%' }">
                    </div>
                </div>

            </div>

        </div>

    </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
export default {
    data: () => ({
        loading: false,
        nro_ticket: null,
        pesaje:null,
        documentos: null,
        ticket_romana: null,
        guias_romana: [],
        conductor: null,
        empresas: [],
        sucursales: [],
        tipo_documentos: [],
        despacho_productos: [],
        tipo_despachos: [],
        /* alert_2:false,
        alert_2_mensaje:'',
        alert_2_clase:'success', */
        errores: [],
        distribuciones_vertedero: [],
        distribuciones_ticket: [],
        distribuciones: [],
        agregar_mps: false,
        alert_mensaje: '',
        alert_class: '',
        alert_icono: '',
        alert_errores: [],
        alert_permisos: [],
        alert: false,
        saving: false,
        showDialog: false,
        dialogMessage: '',
        dialogIcon: 'fas fa-check-circle',
        //duration: 5000, // ms
        progress: 100,
        interval: null,
        loadingMessage: '',
        sistemaPesaje: 'pesamatic'
    }),
    mounted() {
        this.actualizar_titulo('Despacho de Camión')
        this.cargar_tipo_documentos();
        //this.cargar_distribuciones_vertedero();
    },
    methods: {
        async cargar_tipo_documentos() {
            await this.axios.get(`${this.api}/tipo_documentos`, this.cabeceras_json).then((res) => {
                this.tipo_documentos = res.data.data;
            }).catch((e) => {
                //console.log(e);
            });
            this.cargar_despacho_productos();
        },

        setear_kilos(dist, idx) {
            console.log('seleccion', dist)
            if (dist.seleccionado == true) {
                let disponible = dist.peso_real - parseInt(dist.despachado)
                //let despachado = parseInt(dist.despachado) + disponible
                this.$set(this.distribuciones[idx], 'kilos_despacho', disponible)
                //this.$set(this.distribuciones[idx],'despachado',despachado)
            } else {
                /*if(dist.kilos_despacho > 0 && dist.despachado > 0){
                    let despachado = parseInt(dist.despachado) - dist.kilos_despacho
                    this.$set(this.distribuciones[idx],'despachado',despachado)
                }*/
                this.$set(this.distribuciones[idx], 'kilos_despacho', 0)
            }
        },

        /*setear_kilos_input(dist,idx){
            let despachado = (parseInt(dist.despachado_original) + parseInt(dist.kilos_despacho))
            this.$set(this.distribuciones[idx],'despachado',despachado)
            
            console.log('kilos_despacho',dist.kilos_despacho,despachado)
        },*/

        async cargar_despacho_productos() {
            await this.axios.get(`${this.api}/despacho_productos?limit=999999999`, this.cabeceras_json).then((res) => {
                this.despacho_productos = res.data.data.data;
            }).catch((e) => {
                //console.log(e);
            });
            this.cargar_tipo_despachos();
        },

        async cargar_tipo_despachos() {
            await this.axios.get(`${this.api}/tipo_despachos`, this.cabeceras_json).then((res) => {
                this.tipo_despachos = res.data.data;
            }).catch((e) => {
                //console.log(e);
            });
        },

        async cargar_empresas() {
            await this.axios.get(`${this.api}/empresas?limit=999999999`, this.headers).then((res) => {
                this.empresas = res.data.data.data;
            }).catch((e) => {
                comnsole.log(e);
            })
        },
        async consultar_ticket() {
            this.loading = true;
            this.loadingMessage = 'Consultando Ticket, por favor espere...';
            if (this.nro_ticket) {
                this.limpiar_formulario()
                await this.axios.get(`${this.api}/consultar_ticket_despacho/${this.nro_ticket}/${this.sistemaPesaje}`, this.cabeceras_json).then((res) => {
                    //console.log('datos',res.data.data);
                    this.pesaje = res.data.data.pesaje;
                    this.documentos = res.data.data.documentos;
                    this.ticket_romana = res.data.data.ticket_romana;
                    this.guias_romana = res.data.data.guias_romana;
                    this.distribuciones_ticket = res.data.data.distribuciones;
                    /* this.guias_romana.forEach((g,idx) => {
                        this.$set(this.guias_romana[idx],'empresas',[]);
                        this.$set(this.guias_romana[idx],'sucursales',[]);
                    }); */
                    this.conductor = res.data.data.conductor;
                    this.cargar_distribuciones_vertedero()
                }).catch((e) => {
                    //console.log('error',e);
                });
                this.distribuciones_vertedero = []
                this.agregar_mps = false
            }
            this.loading = false;
        },

        calcular_peso_recibido(peso_neto_informado) {
            let porcentaje = (Number(peso_neto_informado) * 100) / this.peso_informado_total;
            let peso_recibido = (porcentaje / 100) * this.pesaje.pesoNetoCorregido;
            return peso_recibido.toFixed(0);
        },


        async filtrarOpciones(busqueda, idx_guia) {
            this.$set(this.guias_romana[idx_guia], 'empresas', []);
            await this.axios.get(`${this.api}/empresas?tipo_empresa_ids=1,4&nombre=${busqueda}&limit=99999999`, this.cabeceras_json).then((res) => {
                this.$set(this.guias_romana[idx_guia], 'empresas', res.data.data.data);
                //this.guias_romana[idx_guia].empresas = res.data.data.data;
            }).catch((e) => {
                //console.log(e);
            });
            //console.log(busqueda,idx_guia);
        },

        async cargarSucursales(empresas_id, idx_guia) {
            //console.log('empresas_id:'+empresas_id,'idx'+idx_guia);
            await this.axios.get(`${this.api}/empresas/${empresas_id}/sucursales`, this.cabeceras_json).then((res) => {
                //console.log('sucursales',res.data.data);
                this.$set(this.guias_romana[idx_guia], 'sucursales', res.data.data);
            }).catch((e) => {
                //console.log(e);
            });
        },

        subirGuia($event, index) {

            //this.file = this.$refs[ref].files[0];
            this.file = $event.target.files[0];
            let formData = new FormData();
            formData.append('file', this.file);
            formData.append('id', this.guias_romana[index].id);
            this.axios.post(`${this.api}/subir_archivo`, formData, this.cabeceras_archivo).then((res) => {
                this.$set(this.guias_romana[index], 'url_guia', res.data.filename);
                this.$set(this.guias_romana[index], 'alert_mensaje', res.data.mensaje);
                this.$set(this.guias_romana[index], 'alert_icono', 'ni ni-check-bold');
                this.$set(this.guias_romana[index], 'alert_clase', 'success');
                this.$set(this.guias_romana[index], 'alert', true);
            })
                .catch((e) => {
                    //console.log(e);
                    this.$set(this.guias_romana[index], 'alert_mensaje', 'No Se Ha podido Cargar la Guía');
                    this.$set(this.guias_romana[index], 'alert_icono', 'fas fa-ban');
                    this.$set(this.guias_romana[index], 'alert_clase', 'danger');
                    this.$set(this.guias_romana[index], 'alert', true);
                });
        },

        async guardarTicket() {
            //this.saving = true;
            this.loading = true;
            this.loadingMessage = 'Guardando información, por favor espere...';
            let body = {
                ticket_romana: this.ticket_romana,
                guias_romana: this.guias_romana,
                distribuciones: this.distribuciones_vertedero.filter(item => item.kilos_despacho > 0),
                //distribuciones_ids:this.ids_distribuciones
            };

            this.alert_mensaje = '';
            this.alert_class = '';
            this.alert_icono = '';
            this.alert_errores = [];
            this.alert_permisos = [];
            this.alert = false;

            await this.axios.post(`${this.api}/ingresar_ticket_despacho`, body, this.cabeceras_json).then(async (res) => {
                // console.log('respuesta ingreso ticket',res.data.success);
                if (res.data.success) {
                    /* this.alert_2_clase = 'success';
                    this.alert_2_mensaje = res.data.mensaje;
                    this.alert_2 = true; */

                    this.openDialog(res.data.mensaje, 'success', 5000);
                    this.limpiar_formulario();
                    /*await this.consultar_ticket();
                    await this.cargar_distribuciones_vertedero();
                    this.nro_ticket = res.data.ticket_romana.codigo_ticket;*/

                } else {
                    /* this.errores = res.data.errores;
                    this.alert_2_clase = 'warning';
                    this.alert_2_mensaje = res.data.mensaje;
                    this.alert_2 = true; */

                    this.alert_mensaje = res.data.mensaje;
                    this.alert_class = 'alert-warning';
                    this.alert_icono = 'fas fa-ban';
                    this.alert_errores = res.data.errores;
                    this.alert_permisos = [];
                    this.alert = true;
                }

            }).catch((e) => {

            })
            this.loading = false;
        },

        limpiar_formulario() {
            this.pesaje = null;
            this.ticket_romana = null;
            this.documentos = [];
            this.guias_romana = [];
            this.errores = [];
            this.conductor = null;
            this.distribuciones_ticket = [];
        },

        agregarDetalle(guia_index) {
            this.guias_romana[guia_index].guia_despacho_detalles.push({
                id: null,
                guias_id: this.guias_romana[guia_index].id,
                despacho_productos_id: null,
                peso_real: null,
                m3: null
            });
        },

        async quitarDetalle(detalle, idx, guia_index) {
            if (detalle.id != null) {
                await this.axios.delete(`${this.api}/elimnar_detalle_despacho/${detalle.id}`, this.cabeceras_json).then((res) => {

                }).catch((e) => {
                    //console.log(e);
                });
            }

            this.guias_romana[guia_index].guia_despacho_detalles.splice(idx, 1);
        },

        retornar_despacho_productos(tipo_despacho_id) {
            return this.despacho_productos.filter(p => p.tipo_despacho_id == tipo_despacho_id);
        },

        /* cerrar_alert_2(){
            this.alert_2_mensaje = '';
            this.alert_2_clase = '';
            this.alert_2 = false;
        }, */

        abrirPdf(archivo) {
            window.open(`${this.api_public}/guias/${archivo}`, '_blank');
        },

        async cargar_distribuciones_vertedero() {
            //$event = $event.replace('?','?destino=5');
            //this.pagina_actual = `${this.api}/guia_distribucion&destino=3,4&limit`;
            //this.lista = [];
            let fecha = this.pesaje.fechaBruto ? this.pesaje.fechaBruto : this.pesaje.fechaTara;
            await this.axios.get(`${this.api}/guia_distribucion_a_vertedero?fecha_ticket=${fecha}`, this.cabeceras_json).then((res) => {
                this.distribuciones_vertedero = res.data.data.map(dist => {
                    return { ...dist, guias_id: dist.guias_id ?? this.guias_romana[0].id }
                });
                this.distribuciones_ticket.forEach((item) => {
                    let idx = this.distribuciones_vertedero.findIndex(item2 => item2.id == item.id);
                    if (!item.guias_id) item.guias_id = this.guias_romana[0].id;
                    if (idx >= 0) {
                        console.log('entra');
                        //let peso_real = item.peso_real + this.distribuciones_vertedero[idx].kilos_despacho
                        //console.log('peso_real',peso_real)
                        //this.$set(this.distribuciones_vertedero[idx2],'peso_real',peso_real)
                        this.$set(this.distribuciones_vertedero[idx], 'despachado', item.despachado)
                        this.$set(this.distribuciones_vertedero[idx], 'kilos_despacho', item.kilos_despacho)
                        this.$set(this.distribuciones_vertedero[idx], 'seleccionado', true)
                        this.$set(this.distribuciones_vertedero[idx], 'guias_id', item.guias_id)
                    } else {
                        this.distribuciones_vertedero.push(item)
                    }
                });
                this.distribuciones = this.distribuciones_vertedero.sort(function (a, b) {
                    // Convert the date strings to Date objects
                    let dateA = new Date(a.fecha_hora_ticket);
                    let dateB = new Date(a.fecha_hora_ticket);

                    // Subtract the dates to get a value that is either negative, positive, or zero
                    return dateA - dateB;
                })
                this.agregar_mps = true
                //this.links = res.data.data.links;
                /* let config = {
                  columnas:this.columnas,
                  lista:this.lista,
                  links:this.links
                } */
                /* this.inicializar_tabla({
                  columnas:this.columnas,
                  lista:this.lista,
                  links:this.links,
                  botones:this.botones
                }); */
                //this.$emit('generar',this.columnas,this.lista);
                //////console.log('listado',res.data.data.data);
                //$('#empresas').DataTable().draw();
            }).catch(e => {
                //alert(e);
            })
        },

        openDialog(message, type = 'success', duration = 3000) {
            this.dialogMessage = message
            this.duration = duration
            this.progress = 100
            this.showDialog = true

            // icono según tipo
            if (type === 'error') this.dialogIcon = 'fas fa-times-circle'
            else if (type === 'warning') this.dialogIcon = 'fas fa-exclamation-triangle'
            else this.dialogIcon = 'fas fa-check-circle'

            let step = 100 / (duration / 50)

            this.interval = setInterval(() => {
                this.progress -= step

                if (this.progress <= 0) {
                    this.closeDialog()
                }
            }, 50)
        },

        closeDialog() {
            this.showDialog = false
            clearInterval(this.interval)
        },

        ...mapActions(['actualizar_titulo'])
    },
    computed: {
        ...mapState(['api', 'api_public', 'cabeceras_json', 'cabeceras_archivo', 'titulo_menu']),

        isEtruck: {
            get() {
                return this.sistemaPesaje === 'etruck';
            },
            set(value) {
                this.sistemaPesaje = value ? 'etruck' : 'pesamatic';
            }
        },

        peso_informado_total() {
            let peso = 0;
            this.documentos.forEach(guia => {
                peso += Number(guia.peso_informado);
            });
            return peso;
        },

        nombre_conductor() {
            if (this.conductor) {
                return `${this.conductor.nombres} ${this.conductor.apellidos}`
            }
            return '';
        },

        peso_neto_corregido_romana() {
            if (this.ticket_romana) {
                return Number(this.ticket_romana.peso_vehiculo_bruto) - Number(this.ticket_romana.peso_vehiculo_tara);
            }
            return '';
        },

        kilos_distribuciones() {
            let dists = this.distribuciones.filter(d => d.seleccionado == true);
            return dists.length > 0 ? dists.reduce(function (acc, obj) { return acc + obj.peso_real; }, 0) : 0;
        },

        kilos_distribuciones_nuevo() {
            return this.distribuciones_vertedero.length > 0 ? this.distribuciones_vertedero.reduce(function (acc, obj) { return parseInt(acc) + parseInt(obj.kilos_despacho); }, 0) : 0;

        },

        ids_distribuciones() {
            return this.distribuciones.filter(d => d.seleccionado == true).map(d => d.id);
        },

        guias_romana_distintas() {
            const guias = {};
            return this.guias_romana.filter(guia => {
                if (guias[guia.numero_guia]) {
                    return false;
                } else {
                    guias[guia.numero_guia] = true;
                    return true;
                }
            });
        }
        /*distribuciones(){
            return this.distribuciones_ticket.concat(this.distribuciones_vertedero);
        }*/
    }
}
</script>
<style>
.auto-dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(3px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.auto-dialog-box {
    width: 320px;
    background: #fff;
    border-radius: 12px;
    padding: 20px 15px 15px;
    text-align: center;
    position: relative;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
    animation: fadeInScale 0.2s ease;
}

.auto-dialog-icon {
    font-size: 40px;
    margin-bottom: 10px;
    color: #7cb518;
}

.auto-dialog-message {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 15px;
}

.auto-dialog-close {
    position: absolute;
    top: 8px;
    right: 10px;
    border: none;
    background: none;
    font-size: 18px;
    cursor: pointer;
}

.auto-dialog-progress {
    height: 4px;
    background: #e5e7eb;
    border-radius: 4px;
    overflow: hidden;
}

.auto-dialog-progress-bar {
    height: 100%;
    background: #7cb518;
    transition: width 0.05s linear;
}

.dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.dialog-box {
    width: 700px;
    max-width: 90%;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    animation: fadeIn 0.2s ease;
}

.dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 15px;
    border-bottom: 1px solid #eee;
}

.dialog-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    color: #dc3545;
}

.dialog-close {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
}

.dialog-body {
    padding: 15px;
    max-height: 300px;
    overflow-y: auto;
}

.dialog-subtitle {
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 5px;
}

.dialog-list {
    padding-left: 18px;
    font-size: 13px;
}

.dialog-list.error li {
    color: #dc3545;
}

.dialog-footer {
    padding: 10px 15px;
    border-top: 1px solid #eee;
    text-align: right;
}


.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(3px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

/* Caja central */
.loading-card {
    background: #ffffff;
    padding: 25px 30px;
    border-radius: 12px;
    text-align: center;
    min-width: 220px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    animation: fadeInScale 0.2s ease;
}

/* Spinner más moderno */
.loading-spinner {
    width: 50px;
    height: 50px;
    border: 5px solid #e5e7eb;
    border-top: 5px solid #7cb518;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    margin: 0 auto 12px;
}

/* Texto */
.loading-message {
    font-size: 14px;
    font-weight: 500;
    color: #374151;
}

.guia-card {
    border-radius: 12px;
    border: 1px solid #e3e6f0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.section-title {
    font-size: 13px;
    font-weight: 600;
    color: #4e73df;
    margin-bottom: 10px;
    padding-left: 8px;
    border-left: 3px solid #4e73df;
}

.form-item {
    margin-bottom: 12px;
}

.form-item label {
    font-size: 12px;
    font-weight: 600;
    color: #6c757d;
    margin-bottom: 4px;
    display: block;
}

.form-control-sm {
    height: 32px;
    font-size: 13px;
}

.gap-2 {
    gap: 6px;
}

.distribucion-row {
    border: 1px solid #e3e6f0;
    border-radius: 8px;
    padding: 10px;
    margin-bottom: 8px;
    background: #fafafa;
}

.distribucion-row:hover {
    background: #f1f5ff;
}

.form-item label {
    font-size: 11px;
    font-weight: 600;
    color: #6c757d;
    margin-bottom: 2px;
    display: block;
}

.form-control-sm {
    height: 30px;
    font-size: 12px;
}

.form-item small {
    font-size: 10px;
}

.upload-box {
    border: 1px dashed #cbd5e0;
    border-radius: 8px;
    padding: 10px;
    background: #f8fafc;
}

.upload-actions {
    margin-bottom: 6px;
}

.upload-input {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    cursor: pointer;
    background: #ffffff;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    padding: 6px;
    font-size: 12px;
    transition: all 0.2s;
}

.upload-input:hover {
    background: #eef2ff;
    border-color: #4e73df;
}

.upload-input i {
    font-size: 14px;
}

.upload-input input {
    display: none;
}

.centro-row {
    border: 1px solid #e3e6f0;
    border-radius: 8px;
    padding: 10px;
    margin-bottom: 8px;
    background: #fafafa;
}

.centro-row:hover {
    background: #f1f5ff;
}

.form-item label {
    font-size: 11px;
    font-weight: 600;
    color: #6c757d;
    margin-bottom: 2px;
    display: block;
}

.form-control-sm {
    height: 30px;
    font-size: 12px;
}

.dato-row {
    border: 1px solid #e3e6f0;
    border-radius: 8px;
    padding: 10px;
    margin-bottom: 8px;
    background: #fafafa;
}

.dato-row:hover {
    background: #f1f5ff;
}

.form-item label {
    font-size: 11px;
    font-weight: 600;
    color: #6c757d;
    margin-bottom: 2px;
    display: block;
}

.form-control-sm {
    height: 30px;
    font-size: 12px;
}

/* MINI UPLOAD */
.upload-mini-input {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    background: #fff;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    padding: 5px 8px;
    font-size: 12px;
}

.upload-mini-input:hover {
    background: #eef2ff;
    border-color: #4e73df;
}

.upload-mini-input input {
    display: none;
}

.upload-hint {
    font-size: 10px;
    color: #6c757d;
    display: block;
    margin-top: 4px;
}

input[type="checkbox"] {
    transform: scale(1.2);
    cursor: pointer;
}

.guia-card-header {
    background: linear-gradient(135deg, #4e73df, #224abe);
    color: #fff;
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 1px;
    text-align: center;
    padding: 12px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
}

.table-modern {
    border: 1px solid #e3e6f0;
    border-radius: 10px;
    overflow: hidden;
}

/* HEADER */
.table-header {
    display: grid;
    grid-template-columns: 120px 200px 100px 100px 120px 80px 70px 80px 120px 120px;
    background: #4e73df;
    color: #fff;
    font-size: 11px;
    font-weight: 600;
    padding: 8px;
    position: sticky;
    top: 0;
    z-index: 2;
}

/* BODY SCROLL */
.table-body {
    max-height: 350px;
    overflow-y: auto;
}

/* ROW */
.table-row {
    display: grid;
    grid-template-columns: 120px 200px 100px 100px 120px 80px 70px 80px 120px 120px;
    padding: 6px 8px;
    font-size: 12px;
    border-bottom: 1px solid #edf2f7;
    align-items: center;
    background: #fff;
    transition: all 0.15s ease;
}

.table-row:hover {
    background: #f1f5ff;
}

/* SELECCION */
.row-selected {
    background: #e6f0ff !important;
    border-left: 3px solid #4e73df;
}

/* INPUTS */
.table-row input,
.table-row select {
    height: 28px;
    font-size: 12px;
}

/* TOTAL */
.total-kilos {
    color: #4e73df;
    font-weight: 800;
    font-size: x-large;
}

/* CHECKBOX */
.table-row input[type="checkbox"] {
    transform: scale(1.1);
    cursor: pointer;
}

.pesaje-switch {
    background: linear-gradient(90deg, #0d1f45, #1e3a8a);
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 8px 12px;
    min-width: 130px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.pesaje-switch .label {
    font-size: 11px;
    color: #fff;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.pesaje-switch .value {
    font-size: 13px;
    font-weight: 700;
    color: #fff;
}

/* SWITCH */
.switch {
    position: relative;
    display: inline-block;
    width: 42px;
    height: 22px;
}

.switch input {
    display: none;
}

.slider {
    position: absolute;
    cursor: pointer;
    background-color: #cbd5e1;
    border-radius: 999px;
    inset: 0;
    transition: 0.3s;
}

.slider:before {
    content: "";
    position: absolute;
    height: 16px;
    width: 16px;
    left: 3px;
    top: 3px;
    background-color: white;
    border-radius: 50%;
    transition: 0.3s;
}

input:checked+.slider {
    background: linear-gradient(135deg, #2563eb, #1d4ed8);
}

input:checked+.slider:before {
    transform: translateX(20px);
}

/* Animaciones */
@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

@keyframes fadeInScale {
    from {
        opacity: 0;
        transform: scale(0.9);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

/* animación */
@keyframes fadeInScale {
    from {
        opacity: 0;
        transform: scale(0.9);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: scale(0.95);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}
</style>

<style scoped>
.spinner-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}

.spinner {
    display: inline-block;
    width: 70px;
    height: 70px;
    border: 8px solid #fff;
    border-radius: 50%;
    border-top-color: #5e72e4;
    animation: rotate 1s linear infinite;
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>